import React, { Component } from 'react';
import NavBar from '../CommonComponent/Navbar/NavBar'
import SideBar from '../CommonComponent/Sidebar/SideBar'
import '../assets/css/style.css'
import { BrowserRouter, Route } from 'react-router-dom'
import './App.css';
// import './css/style.css'

import Dashboard from './content/DashBoard/container/DashBoard';
import Students from './content/Student/Container/Students';
import Parent from './content/Parent/Parent';
import Classes from './content/Classes/Classes'
// import AddStudent from './content/Student/Container/AddStudent';
import Attendance from './content/Attendance/Attendance';
import Subjects from './content/Subject/Subjects';
import Teachers from './content/Teacher/Container/Teachers';
import Marks from './content/Marks/Marks';
import Exams from './content/Exams/Exams';
import Events from './content/Events/Events';
import NoticeBoard from './content/NoticeBoard/NoticeBoard';
// require('bootstrap');


class App extends Component {
    state = {

        sideBarshow: true
    }
    userDetails={
        name:"Deepak Kumar",
        email:"sharma.deepak@gmail.com",
        profilePic:"deepak.JPG"
    }

    sidebarMenu= [
            { id: 1, name: "DashBoard", icon: "fa fa-tachometer" },
            { id: 2, name: "Student", icon: "fa fa-user" },
            { id: 3, name: "Teacher", icon: "fa fa-users" },
            { id: 4, name: "Parent", icon: "fa fa-user-md" },
            { id: 5, name: "Classes", icon: "fa fa-book" },
            { id: 6, name: "Attendance", icon: "fa fa-address-book" },
            { id: 7, name: "Subject", icon: "fa fa-user" },
            { id: 8, name: "Marks", icon: "fa fa-subscript" },
            { id: 9, name: "Exam", icon: "fa fa-file-text" },
            { id: 10, name: "NoticeBoard", icon: "fa fa-address-book" },
            { id: 11, name: "Event", icon: "fa fa-cogs" },
            { id: 12, name: "TimeTable", icon: "fa fa-calendar" },
            
        ]

    render() {

        return (
            <BrowserRouter>
                <div className="wrapper">
                    <div className="sidebar">
                        <SideBar sidebarMenus={this.sidebarMenu} userDetails={this.userDetails} />

                    </div>
                    <div className="content-wrapper">
                        <nav className="topbar "><NavBar userDetails={this.userDetails} /></nav>
                        <div className="container-fluid content">
                            {/* <Dashboard /> */}
                            {/* <Content show={this.state.content} /> */}
                            <Route path="/" exact component={Dashboard} />
                            <Route path="/DashBoard" exact component={Dashboard} />
                            <Route path="/Student" component={Students} />
                            <Route path="/Teacher" component={Teachers} />
                            <Route path="/Parent" component={Parent} />
                            <Route path="/Classes" component={Classes} />
                            <Route path="/Attendance" component={Attendance} />
                            <Route path="/Subject" component={Subjects} />
                            <Route path="/Marks" component={Marks} />
                            <Route path="/Exam" component={Exams} />
                            <Route path="/Event" component={Events}/>
                            <Route path="/TimeTable" render={() => <h1 className="text-center text-info">We are in Progress...</h1>} />
                            <Route path="/NoticeBoard" component={NoticeBoard}/>
                        </div>
                    </div>
                </div>
            </BrowserRouter>

        );
    }
}

export default App;
